import React, { useState } from 'react';
import {
  Table, TableHead, TableBody, TableRow,
  TableCell, TableContainer, Paper, IconButton,
  Typography,
  styled
} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';


const BlackLabel = styled(Typography)(({ theme }) => ({
  fontWeight: 'bold',
  color: '#000000',
}));

export default function SplitPdfTable({ columns, data, companyId }) {

  const handleDownload = (url) => {
    const link = document.createElement('a');
    link.href = url;

    // Extract filename from URL
    const urlParts = url.split('/');
    const filename = urlParts[urlParts.length - 1];

    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <TableContainer component={Paper} sx={{ marginTop: '24px' }}>
      <Table>
        <TableHead>
          <TableRow >
            <TableCell sx={{ fontWeight: 'bold', }}>Order Line</TableCell>
            {columns.map((col) => (
              <TableCell key={col.key} align="center" sx={{ fontWeight: 'bold' }}>
                {col.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data?.map((item, index) => (
            <React.Fragment key={index}>
              {/* Product Row */}
              <TableRow>
                <TableCell sx={{ fontWeight: 'bold' }}>{item.product}</TableCell>
                <TableCell colSpan={columns?.length} />
              </TableRow>
              {/* Box Rows */}
              {item?.boxes?.map((box, bIndex) => (
                <TableRow key={bIndex}>
                  <TableCell sx={{ pl: 4 }}>{box.name}</TableCell>
                  <TableCell align="center">
                    <IconButton onClick={() => handleDownload(box.pdfUrl)}>
                      <DownloadIcon fontSize="small" color='primary' />
                    </IconButton>
                  </TableCell>
                  {companyId === 29 ? (
                    <TableCell align="center">
                      <IconButton onClick={() => handleDownload(box.base64Url)}>
                        <DownloadIcon fontSize="small" color='primary' />
                      </IconButton>
                    </TableCell>
                  ) : null}
                </TableRow>
              ))}
            </React.Fragment>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}